<template>
  <div id="facilitador">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Personal Administrativo
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click.prevent="showDialogAdministrativo()">Nuevo</v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="administrativos"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
            <td>{{ props.item.cargo }}</td>
            <!-- <td>{{ props.item.formacion_profesional }}</td> -->
            <td>{{ props.item.carnet }} {{ props.item.complemento }}</td>
            <td>
              <v-switch
                color="green lighten-1"
                :label="props.item.es_vigente?'activo':'inactivo'"
                v-model="props.item.es_vigente"
                @change="changeEsVigente(props.item.id, props.item.es_vigente)"
                hide-details
              ></v-switch>
            </td>
            <td>
              <!-- <v-btn
                depressed
                icon
                dark
                color="success"
                small
                @click="editItem(props.item)"
              >
                <v-icon small>edit</v-icon>
              </v-btn> -->
              <v-btn
                depressed
                icon
                dark
                color="red"
                small
                @click="confirmEliminado(props.item.id)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  <v-dialog v-model="mdialog" scrollable :width="(size_width>1024?'60%':'100%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Agregar Personal Administrativo</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg fluid class="py-1">
            <v-form ref="formAdministrativo">
              <v-layout rows wrap>
                <v-flex xs12 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Nombres"
                    v-model.trim="administrativo.nombre"
                    :rules="[v => !!v || 'El campo es requerido']"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Paterno"
                    v-model.trim="administrativo.paterno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Materno"
                    v-model.trim="administrativo.materno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Cédula de Identidad"
                    v-model.trim="administrativo.cedula_identidad"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 3) || 'Mínimo 4 dígitos']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Complemento"
                    v-model.trim="administrativo.complemento"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-select
                    :items="departamentosE"
                    label="Expedido"
                    item-text="sigla"
                    item-value="id"
                    v-model="administrativo.expedido"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-menu
                    v-model="fechaNacPrs"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="administrativo.fecha_nacimiento"
                        label="Fecha de Nacimiento"
                        append-icon="event"
                        :rules="[v => !!v || 'El campo es requerido']"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="administrativo.fecha_nacimiento" @input="fechaNacPrs = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-select
                    :items="generos"
                    label="Genero"
                    item-text="genero"
                    item-value="id"
                    v-model="administrativo.genero_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs6 sm4 class="py-0">
                  <v-select
                    :items="estado_civiles"
                    label="Estado Civil"
                    item-text="estado_civil"
                    item-value="id"
                    v-model="administrativo.estadocivil_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex> -->
                <v-flex xs6 sm4 class="py-0" >
                  <v-select
                    :items="formaciones"
                    label="Formación Profesional"
                    item-text="formacion"
                    item-value="id"
                    v-model="administrativo.formacion_profesional"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm4 class="py-0" >
                  <v-select
                    :items="cargos"
                    label="Cargo"
                    item-text="cargo"
                    item-value="id"
                    v-model="administrativo.cargo"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 class="py-0" >
                  <v-select
                    :items="tipo_contratos"
                    label="Tipo de Contrato"
                    item-text="tipo_contrato"
                    item-value="id"
                    v-model="administrativo.tipo_contrato"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingSegip" color="success darken-1" flat @click="createAdministrativo">
            Agregar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mdialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mconfirm" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">Esta seguro(a) de eliminar el registro?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="deleteAdministrativo()">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mconfirm = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
export default {
  name: "facilitador",
  data() {
    return {
      search: "",
      headers: [
        { text: "Nro", align: "left", sortable: false },
        { text: "Nombres y Apellidos ", value: "nombre" },
        { text: "Cargo ", value: "cargo" },
        // { text: "Formación Profesional ", value: "formacion_profesional" },
        { text: "Cédula de Identidad ", value: "carnet" },
        { text: "Estado ", value: "es_vigente" },
        { text: "Acciones", sortable: false, width: "140px" }
      ],
      loading: false,
      loadingSegip: false,
      administrativos: [],
      administrativo: {
        id: '',
        nombre: '',
        paterno: '',
        materno: '',
        cedula_identidad: '',
        complemento: '',
        expedido: '',
        cargo: '',
        formacion_profesional: '',
        tipo_contrato: '',
        fecha_nacimiento: '',
        genero_tipo_id: '',
        estadocivil_tipo_id: ''
      },
      fechaNacPrs: false,
      tipo_contratos: [],
      departamentosE: [],
      cargos: [],
      formaciones: [],
      generos: [],
      estado_civiles: [],
      mdialog: false,
      mconfirm: false,
      size_width: 0,
      dparams: {},
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().director) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getAdministrativos();
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.getWidth);
      this.getWidth();
    });
    this.tipo_contratos = Service.tipoContrato();
  },
  methods: {
    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    getExpedidos(pais_id) {
      Service.expedidos(pais_id).then(response => {
        this.departamentosE = response.data;
      })
      .catch(error => {
        console.error("Error al cargar datos", error);
      });
    },
    getCargoFormacion() {
      Service.cargoFormacion().then(response => {
        this.cargos = response.data.cargo;
        this.formaciones = response.data.formacion;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getGeneroEstadoCivil() {
      Service.generoEstadoCivil().then(response => {
        this.generos = response.data.genero;
        this.estado_civiles = response.data.estado_civil;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getAdministrativos() {
      this.loading = true;
      axios
        .get(Service.getBase() + 'lista/administrativo/' + this.dparams.ie_id, Service.getHeader())
        .then(response => {
          this.loading = false;
          this.administrativos = response.data;
        })
        .catch(error => {
          this.loading = false;
          console.error("Error al cargar registros", error);
        });
    },
    showDialogAdministrativo() {
      this.$refs.formAdministrativo.reset();
      this.getCargoFormacion();
      this.getGeneroEstadoCivil();
      this.getExpedidos(1);
      this.mdialog = true;
    },
    createAdministrativo() {
      if (this.$refs.formAdministrativo.validate()) {
        this.administrativo.complemento = this.administrativo.complemento?this.administrativo.complemento:'';
        this.administrativo.institucioneducativa_id = this.dparams.ie_id;
        this.loadingSegip = true;
        if (Service.validateSegip()) {
          Service.postValidarSegip(this.administrativo).then(response => {
            this.loadingSegip = false;
            if (response.data.valido == 1) {
              this.administrativo.segip_id = response.data.valido;
              this.toast('success', response.data.msg);
              this.saveAdministrativo(this.administrativo);
            } else {
              this.toast('warning', response.data.msg);
            }
          }).catch(error => {
            this.loadingSegip = false;
          });
        } else {
          this.saveAdministrativo(this.administrativo);
        }
      }
    },
    saveAdministrativo(administrativo) {
      this.loadingSegip = true;
      axios
        .post(Service.getBase() + "guarda/administrativo", administrativo, Service.getHeader())
        .then(response => {
          this.loadingSegip = false;
          if (response.data.estado == 200) {
            this.getAdministrativos();
            this.$refs.formAdministrativo.reset();
            this.mdialog = false;
            this.toast("success", "Registro guardado.");
          } else {
            this.toast("warning", response.data.msg);
          }
        })
        .catch(error => {
          this.loadingSegip = false;
          this.toast("error", "No se pudo guardar");
        });
    },
    changeEsVigente(ttec_pa_id, es_vigente) {
      axios
        .put(Service.getBase() + 'modifica/administrativo/' + ttec_pa_id, {es_vigente: es_vigente}, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro modificado.');
          // this.getAdministrativos();
        })
        .catch(error => {
          console.error('Error al modificar', error);
        });
    },
    confirmEliminado(administrativo_id) {
      this.administrativo.id = administrativo_id;
      this.mconfirm = true;
    },
    deleteAdministrativo() {
      axios
        .delete(Service.getBase() + 'elimina/administrativo/' + this.administrativo.id, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro eliminado.');
          this.mconfirm = false;
          this.getAdministrativos();
        })
        .catch(error => {
          console.error('Error al eliminar', error);
        });
    },
    isText: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if(charCode == 32 || charCode == 209 || charCode == 241 || (65 <= charCode && charCode <= 90) || (97 <= charCode && charCode <= 122)) {
        return true;
      } else {
        evt.preventDefault();
        return false;
      }
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWidth);
    }
  }
};
</script>